/*
 * @Author: your name
 * @Date: 2022-10-24 16:27:20
 * @LastEditTime: 2023-06-26 13:06:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/EnvManage/HostMonitor/messages.js
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // 添加主机节点
  addHostTitle: '你好,请添加主机节点',
  addHost: '添加主机',
  addSuccess: '添加成功',
  addFail: '添加失败',
  addHostBatch: '批量添加主机',
  hostIp: '节点IP',
  hostIpRequire: '请输入节点IP',
  hostIpPlaceholder: '请刷新页面重试',
  hostIpCheck: 'IP格式不正确',
  hostIpTip: '存在系统实例时不允许修改服务器地址',
  sshPort: 'SSH端口',
  sshPortRequire: '请输入SSH端口',
  sshPortCheck: 'SSH端口格式不正确',
  count: '账号',
  countRequire: '请输入账号',
  pwd: '密码',
  pwdRequire: '请输入密码',
  submit: '马上添加',
  tag: '标签',
  noTag: '无标签',
  tool: '运维工具',

  // 链接测试
  linkSet: '连接设置',
  set: '设置',
  testLink: '测试连接',
  customHostName: '主机名称',
  userName: '用户名',
  serverAddress: '服务器地址',
  customHostNameRequired: '请输入主机名称',
  userNameRequired: '请输入用户名',
  serverAddressRequired: '请输入服务器地址',
  serverAddressRule: '服务器地址格式不正确',
  setSuccess: '设置成功',
  setFail: '设置失败',
  checkFail: '检查失败',
  testLinkSuccess: '测试连接成功',
  testLinkFail: '测试连接失败',
  sure: '确认',
  cancel: '取消',

  // 系统时间
  systemTime: '系统时间',

  // 更改部署模式
  deploymentMode: '当前部署模式为“{type}环境”，未安装系统实例前可',
  alone: '单机',
  colony: '集群',
  change: '更改',

  // 详情页面
  syncTime: '同步',
  memory: '内存',
  diskInfo: '磁盘空间',
  syncTimeSuccess: '同步时间成功',
  timeZone: '时区',
  timeAndDate: '时间日期',
  diskData: '磁盘分区',
  changeEnvType: '修改环境部署类型',
  changeEnvTip: '修改环境类型，需要先卸载supOS。',
  deleteNodeTip: '删除主机，需要先卸载supOS。',
  goback: '返回',
  all: '全部',
  selectDisk: '请选择磁盘!',
  addDiskSuccess: '添加磁盘成功',
  addDiskFiled: '添加磁盘失败',
  judgeTotalSize: '磁盘容量超过可用容量',
  partitionSuccess: '扩展成功',
  cannotFindDisk: '未添加磁盘,请添加',
  addRightNow: '马上添加',
  group: '卷组',
  diskCannotUse: '当前磁盘配置不可以用，请调整磁盘配置',
  refersh: '刷新',
  createTip: '当前磁盘配置不可用，请参考安装文档进行调整',
  selsectAddDisk: '请选择要添加的磁盘',
  multipleChoices: '可多选',
  addDiskOperationTip: '提示：该操作会格式化该磁盘',
  add: '添加',
  adding: '正在添加中...',
  doing: '正在处理中...',
  createDisking: '正在创建...',
  createDiskFail: '创建失败，请重试',
  createDiskAgain: '格式化, 重新分区',
  resetSize: '重新分区',
  extension: '扩展',

  // 集群主机列表
  addNode: '添加节点',
  aloneAddHost: '单机添加',
  batchAddHost: '批量添加',
  hostNode: '主机节点',
  deleteAll: '全部删除',
  searchTip: '请输入名称或IP搜索',
  notUsed: '未使用',
  viewDetail: '详情',
  delete: '删除',
  deleteSuccess: '删除成功',
  deleteing: '正在删除中...',
  deleteFail: '删除失败',
  deleteConfirm: '删除后需要重新添加，请确认删除？',
  reLinking: '正在重试...',
  downloadFail: '下载失败',
  downloadSuccess: '下载成功',
  systemManager: '系统管理',
  hostTip: '你已创建主机节点,如果要安装系统实例,请回到',
  operatingSystem: '操作系统',
  approach: '(建议升级到Ubuntu 20.04.2)',
});
